@let isMobileView = isMobileView$ | async;

<div class="lang-container">
    <ion-select
        #langSelect
        [formControl]="lang"
        [interfaceOptions]="selectPopoverConfig"
        expandedIcon="caret-up-outline"
        interface="popover"
        justify="end"
        mode="md"
        toggleIcon="caret-down-outline"
    >
        <ion-select-option *ngFor="let lang of languagesEnum | keyvalue: originalOrder" [value]="lang.value">
            {{ 'settings.languages.' + lang.value | translate }}
        </ion-select-option>
        @if (!isMobileView) {
            <ion-icon color="dark" slot="start" src="assets/svg/lang.svg"></ion-icon>
        }
    </ion-select>
    <ion-button (click)="openSelect()" class="btn icon-only" expand="full" fill="clear">
        <div class="flex items-center">
            <ion-icon color="dark" slot="start" src="assets/svg/lang.svg"></ion-icon>
        </div>
    </ion-button>
</div>
